import { render, staticRenderFns } from "./NewVenueSettings.vue?vue&type=template&id=8aa522f6&scoped=true&"
import script from "./NewVenueSettings.vue?vue&type=script&lang=js&"
export * from "./NewVenueSettings.vue?vue&type=script&lang=js&"
import style0 from "./NewVenueSettings.vue?vue&type=style&index=0&id=8aa522f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa522f6",
  null
  
)

export default component.exports